import { Navigate } from "react-router-dom";
import useAuthRoles from "../../../common/hooks/useAuthRoles/useAuthRoles";
import AdminDashboardView from "../components/AdminDashboardView/AdminDashboardView";
import SalesDashboardView from "../components/SalesDashboardView/SalesDashboardView";
import OperatorDashboardView from "../components/OperatorDashboardView/OperatorDashboardView";
import IssuanceDashboardView from "../components/IssuanceDashboardView/IssuanceDashboardView";
import ClaimsDashboardView from "../components/ClaimsDashboardView/ClaimsDashboardView";

const Dashboard = () => {
  const {
    canAccessDashboard,
    isOperatorUser,
    isAdminUser,
    isSalesUser,
    isIssuanceUser,
    isClaimsUser,
  } = useAuthRoles();

  if (!canAccessDashboard) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (isOperatorUser) {
    return <OperatorDashboardView />;
  }

  if (isAdminUser) {
    return <AdminDashboardView />;
  }

  if (isSalesUser) {
    return <SalesDashboardView />;
  }

  if (isIssuanceUser) {
    return <IssuanceDashboardView />;
  }

  if (isClaimsUser) {
    return <ClaimsDashboardView />;
  }
};

export default Dashboard;
